import React from 'react';

import {TimelineLite} from "gsap/TimelineLite";

class WithAnimation extends React.Component {
  constructor(props) {
    super(props);

    this.animationEnter = this.animationEnter.bind(this)
    this.animationLeave = this.animationLeave.bind(this)
    
    let paused = this.pause || true,
      delay = this.delay || 0

    this.Timeline = new TimelineLite({ paused, delay })
  }

  animationEnter({ currentPosition, previousPosition }) {
    if(previousPosition === 'above' && !!this.reverse) {
      this.Timeline.reverse()  
    } else {
      this.Timeline.play()  
    }
  }

  animationStart() {
    this.Timeline.play() 
  }

  animationReverse() {
    this.Timeline.reverse() 
  }

  animationRestart() {
    this.Timeline.restart() 
  }

  animationLeave() {

  }
}

export default WithAnimation;



// WEBPACK FOOTER //
// ./src/components/WithAnimation.js